import React, { createContext, useContext, useState, useCallback } from "react";
import { useCreditBalanceViewModel } from "../pages/company/CompanySettings/CreditHistory/viewmodel/getBalanceViewModle";
import {
  CreditBalance,
  TrialStatus,
} from "../pages/company/CompanySettings/CreditHistory/model/creditHistoryModel";
import { useCreditHistoryViewModel } from "../pages/company/CompanySettings/CreditHistory/viewmodel/creditHistoryViewmodel";

interface BalanceContextType {
  balance: CreditBalance | null;
  setBalance: (balance: CreditBalance) => void;
  fetchBalance: () => Promise<void>;
  handleTrialStatus: () => Promise<void>;
  trailStatus: TrialStatus | null;
  setTrialStatus: (status: TrialStatus) => void;
}

const BalanceContext = createContext<BalanceContextType | undefined>(undefined);

export const BalanceProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [balance, setBalance] = useState<CreditBalance | null>(null);
  const [trailStatus, setTrialStatus] = useState<TrialStatus | null>(null);
  const { fetchBalance: fetchBalanceFromViewModel } =
    useCreditBalanceViewModel();
  const { handleTrialStatus: handleTrialStatusViewModel } =
    useCreditHistoryViewModel();

  const fetchBalance = useCallback(async () => {
    try {
      const result = await fetchBalanceFromViewModel();
      setBalance(result); // Adjust this if fetchBalanceFromViewModel returns an object
    } catch (error) {
      // handle error if needed
    }
  }, [fetchBalanceFromViewModel]);
  
  const handleTrialStatus = useCallback(async () => {
    try {
      const result = await handleTrialStatusViewModel();
      setTrialStatus(result); 
    } catch (error) {
      // handle error if needed
    }
  }, [handleTrialStatusViewModel]);
  return (
    <BalanceContext.Provider
      value={{
        balance,
        setBalance,
        fetchBalance,
        handleTrialStatus,
        trailStatus,
        setTrialStatus,
      }}
    >
      {children}
    </BalanceContext.Provider>
  );
};

export const useBalance = () => {
  const context = useContext(BalanceContext);
  if (!context) {
    throw new Error("useBalance must be used within a BalanceProvider");
  }
  return context;
};

export  const useTrialStatus = () => {
  const context = useContext(BalanceContext);
  if (!context) {
    throw new Error("useTrialStatus must be used within a BalanceProvider");
  }
  return context
}